import React, { useEffect, useState } from 'react';
import './LatestProperties.css';
import Navbar from '../Navbar/Navbar';
import LatestPropertiesC from '../../MyComponents/LatestProperty/LatestProperty';
import SearchAndFilterBar from '../../MyComponents/SearchAndFilterBar/SearchAndFilterBar';
import Footer from '../../MyComponents/Footer/Footer';
import toastService from '../../../services/toastService';
import { postData } from '../../../services/apiServices';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../MyComponents/Loader/Loader';
import { useNavigate } from 'react-router-dom';

function LatestProperties() {
    const [isLoading, setIsLoading] = useState(true);
    const [latestProperties, setLatestProperties] = useState([]);
    const [filterData, setFilterData] = useState(null);
    const userInfo = useSelector((state) => state.user.userInfo);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handlePropertyClick = (propertyData) => {
        console.log(propertyData, "?ASD??");
        navigate(`/propertyOfferDetail/${propertyData?.offerId}`);
    };

    useEffect(() => {
        getFeaturedData();
    }, [filterData]);

    const getFeaturedData = async (apiData) => {
        setIsLoading(true);

        const data = {
            "page": "1",
            "searchkeyword": apiData ? apiData?.searchKeyword : "",
            "District": apiData ? apiData?.place : "",
            "beds": apiData ? apiData?.noOfRooms : "",
            "status": apiData ? apiData?.Status : "",
            "price": apiData ? apiData?.startVal : "",
            "userid": userInfo?.id,
            "expired": "",
            "verification_token": "123456"
        };

        try {
            const result = await postData("/searchproperty", data);
            console.log(result, "ASDFADSA?DSFASD?");
            setIsLoading(false);
            if (result?.message === "success") {
                setLatestProperties(result?.data || []);
            } else {
                setLatestProperties([]);
            }
        } catch (error) {
            console.log(error, "Error");
            toastService.showError("Something went wrong");
            setIsLoading(false);
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <Navbar />
            <div className='main-container'>
                <SearchAndFilterBar onFilterSubmit={getFeaturedData} />
                <h1>Latest Property</h1>
                <div className="parent-container">
                    {latestProperties.length === 0 ? (
                        <p>No property found</p>
                    ) : (
                        latestProperties.map((property, index) => (
                            <LatestPropertiesC
                                key={index}
                                image={property.Pictures}
                                title={property.PropertyName}
                                location={property.District}
                                status={property.PropertyStatus}
                                construction={property.PropertyStatus}
                                type={property.PropertyType}
                                propertyDescripiton={property.Description}
                                price={property?.Price}
                                date={property?.CreatedDate}
                                offerId={property?.id}
                                NoOfRooms={property?.NumberOfRooms}
                                Area={property?.Area}
                                isFeatured={property?.is_featured}
                                is_fav={property?.is_fav}
                                is_fav_id={property?.is_fav_id}
                                handleClick={handlePropertyClick}
                            />
                        ))
                    )}
                </div>
            </div>
        </>
    );
}

export default LatestProperties;
